import { AfterContentInit, Directive, Input, OnDestroy } from "@angular/core";
import { ReplaySubject ,  Subscription } from "rxjs";
import { GenericActions } from "../../redux/generic-actions";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { ReduxRequestsMap } from "../../redux/redux-requests-map.service";
import { GenericRowSelectionFormManager } from "./generic-row-selection-form-manager.service";

@Directive({
    selector: "[row-selection-manager]",
    exportAs: "RowSelectionManager",
})
export class RowSelectionManagerDirective implements OnDestroy, AfterContentInit {
    @Input() public stateProp: string;
    @Input() public rootProp: string;
    @Input() public fieldProp: string;
    @Input("formManagerRef") public formManager: GenericRowSelectionFormManager;

    private state$: Subscription;
    public readonly ngAfterContentInit$ = new ReplaySubject(1);
    public selectedIds: { [key: number]: boolean } = {};
    public allSelected = false;
    public allDetailIdSet: Set<number | string> = new Set();

    public get allDetailIds() {
        return Array.from(this.allDetailIdSet);
    }

    constructor(
        public ngRedux: ImmutableRedux<any>,
        public reduxRequests: ReduxRequestsMap,
    ) { }

    public ngAfterContentInit() {
        this.ngAfterContentInit$.next(true);
        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            this.selectedIds = state.ids;
            this.allSelected = state.allSelected;
            this.dispatchToFormIfNeeded.apply(this, [() => {
                this.formManager.onFormFieldChange(
                    this.fieldProp,
                    Object.keys(this.selectedIds).filter((id) => !!this.selectedIds[id]),
                    { isList: true, startIndex: 1 },
                );
            }]);
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
        this.resetState();
    }

    public resetState() {
        this.ngRedux.dispatchFactory(GenericActions.STATE_RESET, this.rootProp, this.stateProp);
    }

    public dispatchToggleSelect(id: number) {
        this.ngRedux.dispatchFactory(GenericActions.TOGGLE_SELECT, this.rootProp, this.stateProp, id);
    }

    public dispatchToggleAll() {
        if (!!this.allSelected) {
            this.dispatchDeselectAll();
        } else {
            this.dispatchSelectAll();
        }
    }

    public registerSelectable(detailId) {
        this.allDetailIdSet.add(detailId);
    }

    public unregisterSelectable(detailId) {
        this.allDetailIdSet.delete(detailId);
    }

    public dispatchSelectAll() {
        this.ngRedux.dispatchFactory(GenericActions.SELECT_ALL, this.rootProp, this.stateProp, this.allDetailIds);
    }

    public dispatchDeselectAll() {
        this.ngRedux.dispatchFactory(GenericActions.DESELECT_ALL, this.rootProp, this.stateProp);
    }

    public dispatchToFormIfNeeded(cb) {
        if (!!this.formManager) {
            cb();
        }
    }
}
